import { NBNServiceClass } from '@belong/types';

/**
 * Convert a numeric service class into a `NBNServiceClass` type. If given a
 * single argument this will return the corresponding service class. If given
 * two arguments it will return an array with all the service classes between
 * `startIndex` and `endIndex` (inclusive).
 *
 * @example
 *
 *   getServiceClass(0)
 *   // "NBN_SERVICE_CLASS_ZERO"
 *
 *   getServiceClass(0, 2)
 *   // ["NBN_SERVICE_CLASS_ZERO", "NBN_SERVICE_CLASS_ONE", "NBN_SERVICE_CLASS_TWO"]
 */
export function getServiceClass(startIndex: number): NBNServiceClass;
export function getServiceClass(startIndex: number, endIndex?: number): NBNServiceClass[];
export function getServiceClass(startIndex: number, endIndex?: number): NBNServiceClass | NBNServiceClass[] {
  const keys = Object.keys(NBNServiceClass);
  if (startIndex < 0 || startIndex >= keys.length) {
    throw new RangeError('Service class must be between 0 and 34');
  }

  if (typeof endIndex !== 'number') {
    return NBNServiceClass[keys[startIndex]];
  }

  if (endIndex < 0 || endIndex >= keys.length) {
    throw new RangeError('Service class must be between 0 and 34');
  }

  return keys.slice(startIndex, endIndex + 1).map(key => NBNServiceClass[key]);
}
